import { render, staticRenderFns } from "./HomeDurante.vue?vue&type=template&id=4655747e&scoped=true"
import script from "./HomeDurante.vue?vue&type=script&lang=js"
export * from "./HomeDurante.vue?vue&type=script&lang=js"
import style0 from "./HomeDurante.vue?vue&type=style&index=0&id=4655747e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4655747e",
  null
  
)

export default component.exports